module.exports = __webpack_public_path__ + "static/dyson-f7d9688c8e10a0ddee3280142027a226.png";